import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  console.log('ProtectedRoute check:', { user, loading });

  if (loading) {
    return <div>Loading...</div>; // Or a proper loading component
  }

  return user ? children : <Navigate to="/fleet" />;
};

export default ProtectedRoute;
